<template>
    <div class="login">
        <div class="login__holder">
            <div class="login-block--form login__box">
				<div class="login__box-wrap">
					<div class="login__branding fade-in one">
						<router-link class="login__logo" to="/">
							<img class="login__logo-img" src="@/assets/images/logo.png" alt="Logo" title="">
						</router-link>
					</div>
					<transition name="fade">
						<div class="login-block__form fade-in two">
							<transition name="fade">
								<div class="login-block__form__wrap">
									<ValidationObserver v-slot="{ handleSubmit }" ref="loginForm" >
										<form action="" class="login-form" @submit.prevent="handleSubmit(submit)">
											<div class="login-form__top">
												<h2 class="block-title login-form--title">Welcome back!</h2>
												<p class="login-form--text">{{ subtitle }}</p>
											</div>
											<div class="notification-wrap-form">
												<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
											</div>
											<div class="login-form__body">
												<p v-if="logoutMessage" class="login-form--text--token">{{ logoutMessage }}</p>
												<div class="login-form-fieldset input-holder">
													<label for="user-email" id="email-label" class="input-label">Email</label>
													<ValidationProvider rules="required|email" v-slot="{ errors }" class="error-message-holder error-message-holder--block" ref="inputEmailValidator">
														<PartInputBasic v-model="email" :data="DataInputEmail" ref="inputEmail"/>
														<span class="error-message">{{ errors[0]}}</span>
													</ValidationProvider>
												</div>
												<div class="login-form-fieldset input-holder">
													<label for="password" id="password-label" class="input-label">Password</label>
													<div class="input-holder__pass error-message-holder">
														<ValidationProvider rules="required" v-slot="{ errors }" class="error-message-holder error-message-holder--block">
															<PartInputBasic v-model="password" :data="DataInputPassword"/>
															<a href="javascript:;" class="show-pass" @click="showPass" v-if="password">
																<SvgIcon class="show-pass__icon" :iconName="passIcon"/>
															</a>
															<span class="error-message">{{ errors[0]}}</span>
														</ValidationProvider>
													</div>
												</div>
											</div>
											<div class="login-form-fieldset login-form--submit">
												<button type="submit" class="btn login-form-submit-btn" id="login-button">
													<PartLoader v-if="showLoader"/>
													Log in</button>
												<div class="login-form__fp">
													<router-link :to="link" id="forgot_pass-button">Forgot password?</router-link>
												</div>
											</div>
										</form>
									</ValidationObserver>
								</div>
							</transition>
						</div>
					</transition>
				</div>
            </div>
			<PartLoginImage :data="DataLoginImage"/>
        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { required, email } from 'vee-validate/dist/rules';
import PartLoader from '@/components/parts/PartLoader';
import PartInputBasic from '@/components/parts/PartInputBasic';
import PartLoginImage from '@/components/parts/PartLoginImage.vue';
import PartNotifications from '@/components/parts/PartNotifications';

extend('email', {
	...email,
	message: 'Email must be in correct format.'
});

extend('required', {
	...required,
	message: 'This field is mandatory.'
});

export default {
	components: {
		SvgIcon,
		ValidationProvider,
		ValidationObserver,
		PartLoader,
		PartInputBasic,
		PartLoginImage,
		PartNotifications
	},
	data () {
		return {
			notificationsData: {
				type: '',
				msg: ''
			},
			email: '',
			password: '',
			showLoader: false,
			pageIsLoaded: false,
			passIcon: 'ico-eye',
			subtitle: 'Log in to your account',
			DataInputEmail: {
				inputId: 'email-input',
				name: 'email',
				type: 'text',
				inputVal: 'email',
				placeholder: 'Type in your email here...'
			},
			DataInputPassword: {
				inputId: 'password-input',
				name: 'Password',
				type: 'password',
				inputVal: 'password',
				placeholder: 'Type in your password'
			},
			blockForgotPasswordData: {},
			DataLoginImage: {}
		};
	},
	computed: {
		logoutMessage() {
			return this.$store.getters.getLogoutMessage;
		},
		link() {
			// Append email to forgot-password email if valid
			if (this.email && this.$refs?.inputEmailValidator?.errors?.length === 0) {
				return `/forgot-password?email=${this.email}`;
			}

			return '/forgot-password';
		}
	},
	mounted() {
		if (this.$route.query.email) {
			this.$refs.inputEmail.setValue(this.$route.query.email);
		}

		if (this.$route.query.reset) {
			this.subtitle = 'You have successfully reset your password! Log in using your new credentials.';
		}
	},
	methods: {
		showPass() {
			const passwordField = document.querySelector('#password-input');
			if (passwordField.getAttribute('type') === 'password') {
				passwordField.setAttribute('type', 'text');
				this.passIcon = 'ico-eyeslash';
			} else {
				passwordField.setAttribute('type', 'password');
				this.passIcon = 'ico-eye';
			}
		},
		notification(err) {
			this.notificationsData.msg = err;
			this.notificationsData.type = 'danger';
		},
		submit () {
			// Bail if already in progress
			if (this.showLoader) {
				return;
			}

			this.showLoader = true;
			this.notificationsData.msg = '';

			this.$store.dispatch('login', this).then(
				response => {
					this.showLoader = false;
				},
				error => {
					this.showLoader = false;
					let errTxt;

					if (error?.response?.data?.error === 'invalid_grant') {
						errTxt = 'Invalid email or password.';
						this.notification(errTxt);
					} else {
						console.log(error);
						errTxt = 'Unknown error, please refresh and try again.';
						this.notification(errTxt);
					}

					// setTimeout(() => { this.errorMessage = false; }, 3000);

					return Promise.resolve();
				}
			);
		}
	}
};
</script>
<style lang="scss" scoped>
.login-block__form__wrap {
	width: 100%;
}

.login-block__form {
	width: 100%;
}

.login {
	overflow: hidden;

	@include mq ($lg) {
		overflow: auto;
	}
}

.login__branding {
	margin-bottom: 96px;

	@include mq($xl) {
		margin-top: 20px;
	}

	@include mq ($lg) {
		margin-bottom: 50px;
	}
}

.login__logo {
	color: $white;
	display: block;
	max-width: 119px;

	@include mq($xl) {
		max-width: 95px;
	}

	@include mq($lg) {
		max-width: 85px;
	}
}

.login__logo-img {
	display: block;
	width: 100%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.login-form--text {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;
	max-width: 300px;
    margin: 0 auto;
}

.login-form-fieldset {
	margin-bottom: 27px;
}

.login-form {
	transition: $dur $ease;
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $grey-light;
		padding: 15px 20px;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		background-color: $white;

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}

.login__holder {
    display: flex;
    min-height: 100vh;

	@include mq($lg) {
		padding: 40px 0;
	}

	@include mq(320px) {
		padding: 30px 0;
	}
}

.login__box {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 46%;
    flex: 1 0 46%;
	height: 100%;
    margin: auto 0;

	@include mq($lg) {
		max-width: 390px;
		width: 100%;
		flex: auto;
		margin: auto;
	}
}

.login__box-wrap {
	display: flex;
	flex-direction: column;
	height: 100%;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-width: 392px;
	padding: 15px;
}

.login-block__form {
    text-align: center;
	height: 100%;
    display: flex;
    align-items: center;
	width: 100%;
	max-width: 100%;
}

.login-form--title {
    margin-bottom: 20px;
}

.login-form--text {
    color: $fiord;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.08px;
    line-height: 21.6px;
}

.login-form--text--token {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $red;
	max-width: 300px;
    margin: 0 auto 10px;
}

.login-form__body {
    padding: 67px 0 0;

	@include mq($md) {
		padding: 30px 0 0;
	}
}

.login-form--submit {
	.login-form-submit-btn {
		width: 100%;
		position: relative;
		cursor: pointer;
		max-width: 100%;
		padding: 10px;
	}
}

.login-form__fp {
    display: flex;
	text-align: center;
	justify-content: center;
    margin-top: 26px;

	a {
		color: $dodger-blue;
		transition: $dur $ease;

		@include hover {
			color: $fiord;
            opacity: 0.9;
        }
	}
}

.login-form--submit {
    margin-bottom: 64px;
    position: relative;
}

.forget-pass--form {
    .login-form-body {
        padding-top: 40px;
    }
}

.input__wrapper {
	margin-bottom: 0;
}

.input-label {
	text-align: left;
}

.block-title {
	display: block;
	font-family: $font-main;
	font-weight: 500;
	font-size: 24px;
	line-height: 1.2;
	color: $fiord;
}

.btn {
	max-width: 250px;
	position: relative;
}

.input-holder,
.input-holder__pass {
	position: relative;
}

.show-pass {
	position: absolute;
	top: 56%;
	right: 10px;
	transform: translateY(-50%);
	font-size: 14px;
	color: $fiord;
	transition: $dur $ease;

	@include hover {
		color: $dodger-blue;
	}
}
</style>
